import { Modal, Grid } from 'antd';
import type { ModalProps } from 'antd';

const { useBreakpoint } = Grid;

type ResponsiveModalProps = ModalProps;

const MODAL_HEADER_HEIGHT = 55; // px — Ant Design modal header bar

const ResponsiveModal = ({ style, styles, ...props }: ResponsiveModalProps) => {
  const screens = useBreakpoint();
  const isPhone = !screens.sm; // true below 576px

  if (!isPhone) {
    return <Modal style={style} styles={styles} {...props} />;
  }

  // Phone: full-screen sheet.
  //
  // width="100%" + maxWidth override makes it span the full viewport width.
  // top:0, margin:0, padding:0 removes the default vertical centering offset.
  // borderRadius:0 removes rounded corners (they look odd at full-screen).
  // body maxHeight + overflowY makes long forms scroll rather than overflow.
  //
  // dvh (dynamic viewport height) accounts for mobile browser chrome
  // collapsing/expanding — more reliable than vh on phones.
  return (
    <Modal
      width="100%"
      style={{
        top: 0,
        margin: 0,
        maxWidth: '100vw',
        padding: 0,
        ...style, // caller can still override if needed
      }}
      styles={{
        ...styles,
        content: {
          borderRadius: 0,
          minHeight: '100dvh',
          ...styles?.content,
        },
        body: {
          maxHeight: `calc(100dvh - ${MODAL_HEADER_HEIGHT}px)`,
          overflowY: 'auto',
          padding: '16px 16px 24px',
          ...styles?.body,
        },
      }}
      {...props}
    />
  );
};

export default ResponsiveModal;
